import React from 'react';

export const ProgramStructure = () => {
  return (
    <section id="program" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold">Program Details</span>
          <h2 className="text-5xl font-bold text-gray-900 mt-4 mb-4">OSSD Program Structure</h2>
          <p className="text-xl text-gray-600">Complete 7 modules: 4 compulsory + 3 from your chosen stream</p>
        </div>

        {/* Compulsory Modules */}
        <div className="mb-20">
          <h3 className="text-3xl font-bold text-center mb-10">4 Compulsory Modules</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white border-2 border-cyan-300 rounded-xl p-6 hover:shadow-2xl hover:border-cyan-500 transition-all">
              <div className="bg-gradient-to-br from-cyan-500 to-blue-600 text-white w-16 h-16 rounded-lg flex items-center justify-center text-xl font-bold mx-auto mb-4 shadow-lg">ENG</div>
              <h4 className="font-bold text-lg mb-2 text-center">ENG3U</h4>
              <p className="text-sm text-gray-600 mb-2 text-center font-semibold">Grade 11 English</p>
              <p className="text-sm text-gray-600 text-center">Advanced language and literature studies</p>
            </div>
            <div className="bg-white border-2 border-cyan-300 rounded-xl p-6 hover:shadow-2xl hover:border-cyan-500 transition-all">
              <div className="bg-gradient-to-br from-cyan-500 to-blue-600 text-white w-16 h-16 rounded-lg flex items-center justify-center text-xl font-bold mx-auto mb-4 shadow-lg">ENG</div>
              <h4 className="font-bold text-lg mb-2 text-center">ENG4U</h4>
              <p className="text-sm text-gray-600 mb-2 text-center font-semibold">Grade 12 English</p>
              <p className="text-sm text-gray-600 text-center">University-level composition and analysis</p>
            </div>
            <div className="bg-white border-2 border-cyan-300 rounded-xl p-6 hover:shadow-2xl hover:border-cyan-500 transition-all">
              <div className="bg-gradient-to-br from-cyan-500 to-blue-600 text-white w-16 h-16 rounded-lg flex items-center justify-center text-xl font-bold mx-auto mb-4 shadow-lg">MHF</div>
              <h4 className="font-bold text-lg mb-2 text-center">MHF4U</h4>
              <p className="text-sm text-gray-600 mb-2 text-center font-semibold">Advanced Functions</p>
              <p className="text-sm text-gray-600 text-center">Mathematical functions for university</p>
            </div>
            <div className="bg-white border-2 border-cyan-300 rounded-xl p-6 hover:shadow-2xl hover:border-cyan-500 transition-all">
              <div className="bg-gradient-to-br from-cyan-500 to-blue-600 text-white w-16 h-16 rounded-lg flex items-center justify-center text-xl font-bold mx-auto mb-4 shadow-lg">MCV</div>
              <h4 className="font-bold text-lg mb-2 text-center">MCV4U</h4>
              <p className="text-sm text-gray-600 mb-2 text-center font-semibold">Calculus and Vectors</p>
              <p className="text-sm text-gray-600 text-center">Advanced mathematics preparation</p>
            </div>
          </div>
        </div>

        {/* Streams */}
        <div>
          <h3 className="text-3xl font-bold text-center mb-10">Choose Your Stream (3 Modules)</h3>
          <div className="grid lg:grid-cols-3 gap-8">
            
            {/* Science Stream */}
            <div className="bg-white border-2 border-green-300 rounded-2xl overflow-hidden hover:shadow-2xl transition-all">
              <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white p-6 text-center">
                <h4 className="text-2xl font-bold">Science Stream</h4>
                <p className="text-green-100 mt-2">Medicine • Research • Life Sciences</p>
              </div>
              <div className="p-6 space-y-4">
                <div className="border-l-4 border-blue-500 pl-4 py-2 bg-gray-50">
                  <p className="font-bold">SBI4U - Biology</p>
                  <p className="text-sm text-gray-600">Biochemistry, genetics, homeostasis</p>
                </div>
                <div className="border-l-4 border-blue-500 pl-4 py-2 bg-gray-50">
                  <p className="font-bold">SCH4U - Chemistry</p>
                  <p className="text-sm text-gray-600">Organic chemistry, reactions, equilibrium</p>
                </div>
                <div className="border-l-4 border-blue-500 pl-4 py-2 bg-gray-50">
                  <p className="font-bold">SPH4U - Physics</p>
                  <p className="text-sm text-gray-600">Kinematics, forces, energy, waves</p>
                </div>
              </div>
            </div>

            {/* Business Stream */}
            <div className="bg-white border-2 border-purple-300 rounded-2xl overflow-hidden hover:shadow-2xl transition-all">
              <div className="bg-gradient-to-r from-purple-500 to-indigo-600 text-white p-6 text-center">
                <h4 className="text-2xl font-bold">Business Stream</h4>
                <p className="text-purple-100 mt-2">Finance • Management • Economics</p>
              </div>
              <div className="p-6 space-y-4">
                <div className="border-l-4 border-blue-500 pl-4 py-2 bg-gray-50">
                  <p className="font-bold">BBB4M - International Business</p>
                  <p className="text-sm text-gray-600">Global markets and trade strategies</p>
                </div>
                <div className="border-l-4 border-blue-500 pl-4 py-2 bg-gray-50">
                  <p className="font-bold">BOH4M - Business Leadership</p>
                  <p className="text-sm text-gray-600">Management and organizational behavior</p>
                </div>
                <div className="border-l-4 border-blue-500 pl-4 py-2 bg-gray-50">
                  <p className="font-bold">CIA4U - Economic Issues</p>
                  <p className="text-sm text-gray-600">Macro and microeconomic analysis</p>
                </div>
              </div>
            </div>

            {/* Computing Stream */}
            <div className="bg-white border-2 border-orange-300 rounded-2xl overflow-hidden hover:shadow-2xl transition-all">
              <div className="bg-gradient-to-r from-orange-500 to-red-600 text-white p-6 text-center">
                <h4 className="text-2xl font-bold">Computing & Engineering</h4>
                <p className="text-orange-100 mt-2">Software • AI • Technology</p>
              </div>
              <div className="p-6 space-y-4">
                <div className="border-l-4 border-blue-500 pl-4 py-2 bg-gray-50">
                  <p className="font-bold">ICS4U - Computer Science</p>
                  <p className="text-sm text-gray-600">Programming and algorithms</p>
                </div>
                <div className="border-l-4 border-blue-500 pl-4 py-2 bg-gray-50">
                  <p className="font-bold">TEJ4M - Computer Engineering</p>
                  <p className="text-sm text-gray-600">Hardware and embedded systems</p>
                </div>
                <div className="border-l-4 border-blue-500 pl-4 py-2 bg-gray-50">
                  <p className="font-bold">MDM4U - Data Management</p>
                  <p className="text-sm text-gray-600">Statistics and data analysis</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Summary */}
        <div className="mt-16 bg-blue-50 border-2 border-blue-200 rounded-2xl p-8 text-center">
          <div className="grid md:grid-cols-3 gap-6">
            <div>
              <p className="text-4xl font-bold text-blue-600">7</p>
              <p className="text-gray-700 font-medium">Total Modules</p>
            </div>
            <div>
              <p className="text-4xl font-bold text-blue-600">12-18</p>
              <p className="text-gray-700 font-medium">Months Duration</p>
            </div>
            <div>
              <p className="text-4xl font-bold text-blue-600">100%</p>
              <p className="text-gray-700 font-medium">University Ready</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
